import _uniq from 'lodash/uniq';

import { TJob } from './isJob';

export default function (job: Pick<TJob, 'jobFields'>) {
	return _uniq(job.jobFields?.map((field) => field.id)).length || 0;
}
